module.exports = function() {
  return new Worker(__webpack_public_path__ + "c449854088a52cd9d2cf.worker.js");
};